import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import DataTable from '../../../components/DataTable/DataTable';
import ATFeedbackQuestion from './ATFeedbackQuestion';
import FieldSetNewAssessmentTabular
    from '../../../components/FieldSetNewAssessmentTabular/FieldSetNewAssessmentTabular';

class QuestionnaireFormTabular extends React.Component {
    componentDidMount() {
    }

    render() {
        const { AT_FEEDBACK_QUESTION_ID } = process.env;
        let { questions } = this.props;
        const atFeedbackQuestion = questions.find(question =>
            question.id === AT_FEEDBACK_QUESTION_ID);
        questions = questions.filter(question => question.id !== AT_FEEDBACK_QUESTION_ID);
        const { options } = questions[0];
        const data = questions.map(question => ({
            question: question.text,
            question_id: question.id,
            accurate_id: question.options.find(option => option.type === 'Accurate').id,
            moderately_accurate_id: question.options.find(option => option.type === 'Moderately Accurate').id,
            neither_id: question.options.find(option => option.type === 'Neither').id,
            moderately_inaccurate_id: question.options.find(option => option.type === 'Moderately Inaccurate').id,
            inaccurate_id: question.options.find(option => option.type === 'Inaccurate').id,
            options: question.options,
        }));
        const columns = [
            {
                accessor: 'question',
                Cell: props => props.data.question,
                sortable: false,
                title: '',
            },
            {
                accessor: 'accurate',
                Cell: props => (
                    <Field
                        name={`${props.data.question_id}`}
                        render={fieldProps => (
                            <FieldSetNewAssessmentTabular
                                data={props.data}
                                optionId={props.data.accurate_id}
                                options={props.data.options}
                                {...fieldProps}
                            />
                        )}
                    />
                ),
                sortable: false,
                title: options.find(option => option.type === 'Accurate').text,
            },
            {
                accessor: 'moderatelyAccurate',
                Cell: props => (
                    <Field
                        name={`${props.data.question_id}`}
                        render={fieldProps => (
                            <FieldSetNewAssessmentTabular
                                data={props.data}
                                optionId={props.data.moderately_accurate_id}
                                options={props.data.options}
                                {...fieldProps}
                            />
                        )}
                    />
                ),
                sortable: false,
                title: options.find(option => option.type === 'Moderately Accurate').text,
            },
            {
                accessor: 'neither',
                Cell: props => (
                    <Field
                        name={`${props.data.question_id}`}
                        render={fieldProps => (
                            <FieldSetNewAssessmentTabular
                                data={props.data}
                                optionId={props.data.neither_id}
                                options={props.data.options}
                                {...fieldProps}
                            />
                        )}
                    />
                ),
                sortable: false,
                title: options.find(option => option.type === 'Neither').text,
            },
            {
                accessor: 'moderatelyInaccurate',
                Cell: props => (
                    <Field
                        name={`${props.data.question_id}`}
                        render={fieldProps => (
                            <FieldSetNewAssessmentTabular
                                data={props.data}
                                optionId={props.data.moderately_inaccurate_id}
                                options={props.data.options}
                                {...fieldProps}
                            />
                        )}
                    />
                ),
                sortable: false,
                title: options.find(option => option.type === 'Moderately Inaccurate').text,
            },
            {
                accessor: 'inaccurate',
                Cell: props => (
                    <Field
                        name={`${props.data.question_id}`}
                        render={fieldProps => (
                            <FieldSetNewAssessmentTabular
                                data={props.data}
                                optionId={props.data.inaccurate_id}
                                options={props.data.options}
                                {...fieldProps}
                            />
                        )}
                    />
                ),
                sortable: false,
                title: options.find(option => option.type === 'Inaccurate').text,
            },
        ];
        const sortable = false;
        const pageable = false;

        return (
            <React.Fragment>
                <DataTable
                    className="data-table"
                    columns={columns}
                    data={data}
                    sortable={sortable}
                    pageable={pageable}
                    activeId={this.props.activeId}
                    stickyHeader
                />
                {atFeedbackQuestion ? (
                    <Field
                        name={`${atFeedbackQuestion.id}`}
                        render={fieldProps => (
                            <ATFeedbackQuestion
                                question={atFeedbackQuestion}
                                {...fieldProps}
                            />
                        )}
                    />
                ) : null}
            </React.Fragment>
        );
    }
}
QuestionnaireFormTabular.propTypes = {
    questions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({})),
    activeId: PropTypes.number,
};
QuestionnaireFormTabular.defaultProps = {
    options: [],
    activeId: 0,
};

export default QuestionnaireFormTabular;
